import Card from 'react-bootstrap/Card';
import { getStatusColor } from './GetStatusColor';
import InfoOverlay from '../../../components/InfoOverlay';
import BiddingsBtnGroup from './BiddingsBtnGroup';

function VehicleCard({
  vehicle,
  setShowChangeStatusError,
  competitionId,
  competitionStatus,
  setVehicles,
}) {
  return (
    <Card>
      <Card.Body>
        <div className='d-flex gap-2 align-items-center justify-content-between'>
          <div className='d-flex gap-2 align-items-center'>
            {vehicle.racingNumbers?.map((rn, index) => (
              <span key={index} className='bg-secondary-black text-white p-1'>
                {rn}
              </span>
            ))}
          </div>
          <div className='d-none d-sm-flex gap-2'>
            <span className='text-secondary'>Status</span>
            <span className={getStatusColor(vehicle?.bidStatus) + ' px-1'}>
              {vehicle.translatedBidStatus}
            </span>
          </div>
          <div className='d-flex gap-2'>
            <span className='text-secondary'>Antal anbud</span>
            <span className='bg-light px-1'>{vehicle.numberOfBids}</span>
          </div>
        </div>
        <div className='d-flex d-sm-none mt-3 gap-2 justify-content-between'>
          <span className='text-secondary'>Status</span>
          <span className={getStatusColor(vehicle?.bidStatus) + ' px-1'}>
            {vehicle.translatedBidStatus}
          </span>
        </div>
        <div className='d-flex justify-content-between mt-2'>
          <span className='text-secondary'>Vinnare</span>
          <span className='px-1'>
            {vehicle.bidWinner ? (
              <InfoOverlay
                name={vehicle.bidWinner}
                info={vehicle.bidWinnerDetails}
                winnerInfo={true}
              />
            ) : (
              <></>
            )}
          </span>
        </div>
        <Card.Footer
          className='mt-2'
          style={{ paddingLeft: '0', paddingRight: '0' }}
        >
          <BiddingsBtnGroup
            competitionStatus={competitionStatus}
            competitionId={competitionId}
            setShowChangeStatusError={setShowChangeStatusError}
            vehicle={vehicle}
            setVehicles={setVehicles}
          />
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default VehicleCard;
